export default __webpack_public_path__ + "static/media/pkb-3.acfe587f.png";